import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface IAgTwoLineCellRendererParams {
  // Bold first line; defaults to the formatted cell value.
  primary?: (params: ICellRendererParams) => string;
  // Muted second line; omitted when empty.
  secondary?: (params: ICellRendererParams) => string;
}

// Renders a cell as a bold primary line with a muted secondary line underneath
// (e.g. "CY 2026" over "1/1/2026 – 12/31/2026"). Pair with a rowHeight that fits two lines.
@Component({
    selector: 'app-ag-two-line-cell-renderer',
    templateUrl: './ag-two-line-cell-renderer.component.html',
    styleUrl: './ag-two-line-cell-renderer.component.scss'
})
export class AgTwoLineCellRendererComponent implements ICellRendererAngularComp {

  primary = '';
  secondary = '';

  agInit(params: ICellRendererParams & IAgTwoLineCellRendererParams): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams & IAgTwoLineCellRendererParams): boolean {
    this.setValue(params);
    return true;
  }

  private setValue(params: ICellRendererParams & IAgTwoLineCellRendererParams) {
    this.primary = params.primary ? params.primary(params) : `${params.valueFormatted ?? params.value ?? ''}`;
    this.secondary = params.secondary ? params.secondary(params) : '';
  }
}
